<template>
  <Popup v-model="popupShow" class="aip">
    <div class="content">
      <div class="e1">
        <div class="tip">实名认证</div>
        <div class="btn" @click="closeBtnHandle">
          <i class="fa fa-close" />
        </div>
      </div>

      <div class="e2" v-show="true">
        <div class="tips">
          <!-- <div>系统自动打款需要完善个人账户信息</div> -->
          <div>应监管要求，提卡需实名认证，请填写您本人真实姓名和身份证号，未认证将无法完成操作，不支持修改，请核对后提交</div>
        </div>
      </div>

      <!-- <Divider :style="{ borderColor: '#d2d2d2' }" /> -->

      <div class="inputbox">
        <Form
          ref="form"
          validate-trigger="onSubmit"
          label-width="60"
          @submit="onInputOk"
        >
          <Field
            v-model="form.username"
            name="username"
            label="姓  名"
            maxlength="8"
            clearable
            placeholder="请输入本人姓名"
            :rules="[{ required: true, message: '姓名不能为空哦' }]"
          />
          <Field
            v-model="form.idcard"
            name="phone"
            label="身份证号"
            maxlength="18"
            clearable
            placeholder="请输入本人身份证号"
            :rules="[
              { required: true, message: '身份证号不能为空哦' },
              { validator: validateIdCard, message: '身份证号码格式错误' },
            ]"
          />
          <div>
            <Button
              block
              type="info"
              size="middle"
              :loading="formBtnLoading"
              :text="formBtnText"
              :loading-text="formBtnLoadingText"
              :disabled="!formBtnStatus"
              native-type="submit"
            />
          </div>
        </Form>
      </div>      
    </div>
  </Popup>
</template>

<script>
import { Popup, Form, Field, Button, Toast  } from "vant";


export default {
  name: "AccountInfoPopup",
  components: { Popup, Form, Field, Button },
  data() {
    return {
      popupShow: false,
      formBtnText: "提\u3000\u3000交",
      formBtnLoading: false,
      formBtnLoadingText: "正在处理，客官请稍后",
      formBtnStatus: true,
      form: {
        username: "",
        idcard: "",
      },
      mobilePattern: /1[3456789]\d{9}/,
      confirmAccountInfoShow: false,
    };
  },
  methods: {
    show() {
      this.popupShow = true;
    },
    close() {
      this.popupShow = false;
    },
    closeBtnHandle() {
      this.$refs["form"].resetValidation();
      this.popupShow = false;
    },
    onInputOk() {
      this.$emit('success', this.form)
    },
    validateIdCard(val) {
      return /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(val)
    },
    sendSmsSuccessTip() {
      Toast({
        message: "验证码已发送",
        icon: "envelop-o",
      });
    },
    mock1() {
      this.formBtnStatus = false;
      this.formBtnLoading = true;
      setTimeout(() => {
        this.formBtnLoading = false;
        this.formBtnStatus = true;
      }, 3500);
    },
  },
};
</script>

<style>
.aip {
  width: 85%;
  min-height: 280px;
  background-color: #f5f5f5;
  border-radius:5px;
  padding: 10px;
}
.aip .content {
  padding: 10px 12px;
  
}
.aip .content .e1 {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
  font-weight: bold;
  font-size: 20px;
}
.aip .content .e1 .btn {
  color: #41add6;
  font-size: 20px;
}
.aip .content .e2 {
  font-size: 13px;
  text-align: left;
}
.tips{
  color: #666;
  margin-bottom:15px ;
}
.inputbox{
  margin-bottom: 5px;
}
.inputbox button{
  margin-top: 15px;
}
.aip .van-cell{
  box-shadow: rgba(0, 0, 0, 0.151) 0 0 10px;
  border-radius: 5px;
  margin: 5px 0;
  padding: 5px 10px;
  line-height: 35px;
}
</style>